import { Component, Output, EventEmitter } from '@angular/core';
import { BaseComponent } from '@app/directives/base-component';

@Component({
    selector: 'c_side_modal_site_note_component',
    templateUrl: './c_side_modal_site_note.component.html',
    styleUrls: ['../common.scss', '../c_side_modal.component.scss'],
    standalone: false
})
export class c_side_modal_site_note_component extends BaseComponent {

  constructor() { super(); }

}
